import { addDays, differenceInDays } from './dateFormatter'

interface IAccessDays {
  expireDate: string
  availableUntil?: string
  availableTimeLength?: number
  activatedAt: string
}

export function getAccessDays({
  availableUntil,
  expireDate,
  availableTimeLength,
  activatedAt,
}: IAccessDays) {
  if (availableUntil) {
    return {
      days: differenceInDays(new Date().toDateString(), availableUntil),
      expireDate: availableUntil,
    }
  }
  if (expireDate) {
    return {
      days: differenceInDays(new Date().toDateString(), expireDate),
      expireDate,
    }
  } else if (availableTimeLength) {
    return {
      days: differenceInDays(
        new Date().toDateString(),
        addDays(activatedAt, availableTimeLength),
      ),
      expireDate: addDays(activatedAt, availableTimeLength),
    }
  }
  return null
}
